import { ROL } from '../services/roles'

export function AdminAndCompanyAdmin() {
  return (rol) => [ROL.ADMIN, ROL.COMPANY_ADMIN].includes(rol)
};

export function NotAnalyst() {
  return (rol) => rol !== ROL.ANALYST
};

export function NotAccounting() {
  return (rol) => rol !== ROL.ACCOUNTING
};

export function OnlyAdmin() {
  return (rol) => rol === ROL.ADMIN
};

export function OnlyAdminAndAccounting() {
  return (rol) => [ROL.ADMIN, ROL.ACCOUNTING].includes(rol)
};

export function OnlyRisk() {
  return (rol) => [ROL.ADMIN, ROL.RISK_SHIELD, ROL.RISK_SHIELD_ADMIN].includes(rol)
};

export function OnlyRiskAndAnalyst() {
  return (rol) => [ROL.ADMIN, ROL.RISK_SHIELD, ROL.ANALYST, ROL.RISK_SHIELD_ADMIN].includes(rol)
};

// XAN-195 — read-only access to the Viáticos panel: the Risk team plus Accounting, who may only
// view the amount, "Cobrar al cliente" and "Aprobado por", never edit them.
export function OnlyRiskAndAccounting() {
  return (rol) => [ROL.ADMIN, ROL.RISK_SHIELD, ROL.RISK_SHIELD_ADMIN, ROL.ACCOUNTING].includes(rol)
};

// Read-only access to the Servicios tab: same as OnlyRiskAndAnalyst plus Accounting, who may only
// view which analyst worked each service, never assign/edit/qualify it.
export function OnlyRiskAnalystAndAccounting() {
  return (rol) => [ROL.ADMIN, ROL.RISK_SHIELD, ROL.ANALYST, ROL.RISK_SHIELD_ADMIN, ROL.ACCOUNTING].includes(rol)
};

export function ComplianceAndAdmin() {
  return (rol) => [ROL.ADMIN, ROL.COMPLIANCE, ROL.COMPLIANCE_ADMIN, ROL.COMPANY_COMPLIANCE].includes(rol)
};

export function AdminCompliance() {
  return (rol) => [ROL.COMPLIANCE_ADMIN].includes(rol)
};

export function NotCompliance() {
  return (rol) => ![ROL.COMPLIANCE, ROL.COMPLIANCE_ADMIN, ROL.COMPANY_COMPLIANCE].includes(rol)
};

export function NotClientCompliance() {
  return (rol) => rol !== ROL.COMPANY_COMPLIANCE
};

export function OnlyClientCompliance() {
  return (rol) => rol === ROL.COMPANY_COMPLIANCE
};

export function OnlyCompany() {
  return (rol) => [ROL.COMPANY_ADMIN, ROL.COMPANY].includes(rol)
};

export function adminAndRiskAdmin() {
  return (rol) => [ROL.ADMIN, ROL.RISK_SHIELD_ADMIN].includes(rol)
};

export function canSubmitToApproval() {
  return (rol) => [ROL.ADMIN, ROL.RISK_SHIELD_ADMIN, ROL.RISK_SHIELD].includes(rol)
};

export function complianceRisk() {
  return (rol) => [ROL.COMPLIANCE, ROL.COMPLIANCE_ADMIN,].includes(rol)
};

export function CanApprove() {
  return (rol) => [ROL.ADMIN, ROL.CLIENT_APPROVER].includes(rol)
};

export function OnlyClientApprover() {
  return (rol) => rol === ROL.CLIENT_APPROVER
};

export function NotClientApprover() {
  return (rol) => rol !== ROL.CLIENT_APPROVER
};

export function OnlyCompanyAdmin() {
  return (rol) => rol === ROL.COMPANY_ADMIN
};

export function CanBulkUpload() {
  return (rol) => [ROL.ADMIN, ROL.RISK_SHIELD, ROL.RISK_SHIELD_ADMIN, ROL.COMPANY_ADMIN, ROL.COMPANY].includes(rol)
};

// XAN-24 / XAN-193 (adjustments) — access to the ticket manager: the six roles that may be
// assigned to a project. ANALYST is excluded from the whole module, and so are the client-facing
// roles. Renamed from OnlyRiskTeam because the list stopped being "the Risk Shield team".
//
// Holding one of these roles only opens the module: what each user actually sees is decided by
// project membership, enforced by the backend. The Projects screen does NOT use this helper —
// managing projects is ADMIN-only (see OnlyAdmin).
export function TicketModuleAccess() {
  return (rol) => [
    ROL.ADMIN, ROL.RISK_SHIELD, ROL.RISK_SHIELD_ADMIN,
    ROL.COMPLIANCE, ROL.COMPLIANCE_ADMIN, ROL.ACCOUNTING
  ].includes(rol)
};